/**
 * Created by staffanrantzow on 15/03/16.
 */

/* @flow */
import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import DatepickerRange from 'components/datepicker-range/datepicker-range';
import { connect } from 'react-redux';
import SalaryService from 'frilans-finans/salaries/salary-service';
import SalaryRow from './salary-row';
import SalarySums from './salary-sums';
import ReactPaginate from 'react-paginate';
import Spinner from 'components/spinner/spinner';
import { SpinnerPage } from 'frilans-finans/spinner/spinner-page';
import {
  paidPaymentStatus, paidByFileCategory,
  paidManuallyCategory,
  paidInCashCategory,
  creditCategory
} from '../../../frilans-finans/invoices/invoice-constants';

export class Salaries extends React.Component {

  static propTypes = {
    dateFilter: PropTypes.object.isRequired,
    user: PropTypes.object
  };

  constructor (props) {
    super(props);

    this.state = {
      salaries: [],
      selectAllSalaries: false,
      fetchingMore: false,
      fetchingInitial: true,
      fetchError: false,
      contentFetched: false,
      page: 1,
      size: 25,
      pageRange: 5,
      meta: {
        totalPages: 1
      },
      salarySums: {
        net: 0,
        gross: 0,
        tax: 0,
        travel: 0,
        allowance: 0
      },
      pendingRequest: null,
      salarySpecification: null,
      openSalarySpecification: false,
      salarySpecificationWindow: null
    };
  }

  componentWillMount () {
    this.fetchSalariesAndSalarySums(this.props);
  }

  componentWillUnmount () {
    if (this.state.pendingRequest && this.state.pendingRequest.cancel) {
      this.state.pendingRequest.cancel();
    }
  }

  componentWillReceiveProps (nextProps) {
    this.fetchSalariesAndSalarySums(nextProps);
  }

  componentDidUpdate (prevProps, prevState) {
    this.openSalarySpecification();
  }

  openSalarySpecification = () => {
    if (this.state.salarySpecification &&
      this.state.openSalarySpecification &&
      this.state.salarySpecificationWindow) {
      this.state.salarySpecificationWindow.location = this.state.salarySpecification.specification_pdf_url;

      this.setState({
        openSalarySpecification: false,
        salarySpecificationWindow: null
      });
    }
  }

  selectAllSalaries = () => {
    const salaries = this.state.salaries;

    this.setState({
      selectAllSalaries: !this.state.selectAllSalaries
    }, () => {
      salaries.forEach(salary => {
        salary.selected = this.state.selectAllSalaries;
      });

      this.setState({
        salaries: salaries
      });
    });
  }

  toggleSalary = (salaryId) => {
    const salaries = this.state.salaries;
    let selectAllSalaries = this.state.selectAllSalaries;

    salaries.forEach(salary => {
      if (salary.id === salaryId) {
        salary.selected = !salary.selected;

        if (!salary.selected) {
          selectAllSalaries = false;
        }
      }
    });

    this.setState({
      salaries: salaries,
      selectAllSalaries: selectAllSalaries
    });
  }

  handleSalarySpecificationResponse = (apiResult) => {
    this.setState({
      salarySpecification: apiResult,
      openSalarySpecification: true
    });
  }

  createSalarySpecification = (salaryIds) => {
    let pendingRequest = SalaryService.createSalarySpecification(salaryIds);
    pendingRequest.promise
      .then((response) => this.handleSalarySpecificationResponse(response))
      .catch(error => {
        if (error.response !== undefined) {
          this.state.salarySpecificationWindow.close();

          this.setState({
            openSalarySpecification: false,
            salarySpecificationWindow: null
          });

          alert(proxyCounterpart('GET_SALARY_SPECIFICATION_ERROR'));
        }
      });

    return pendingRequest;
  }

  fetchSalariesAndSalarySums = (props) => {
    if (typeof props.user.id !== 'undefined') {
      this.setState({
        fetchingMore: true,
        invoices: [],
        fetchingInitial: true,
        meta: {
          currentPage: 0
        }
      }, () => this.fetchSalaries(props.user.id, props.dateFilter));

      this.fetchSalarySums(props.user.id, props.dateFilter);
    }
  }

  fetchSalaries = (userId, dateFilter) => {
    let pendingRequest = SalaryService.get(userId, this.state.page, this.state.size, dateFilter, '-paid_at');
    pendingRequest.promise
      .then((response) => this.handleResponse(response))
      .catch(error => {
        if (error.response !== undefined) {
          this.setState({
            fetchError: true,
            fetchingMore: false,
            fetchingInitial: false
          });
        }
      });

    this.setState({
      pendingRequest: pendingRequest
    });
  }

  fetchSalarySums = (userId, dateFilter) => {
    let pendingRequest = SalaryService.getSums(userId, dateFilter);
    pendingRequest.promise
      .then((response) => this.handleSumResponse(response))
      .catch(error => {
        if (error.response !== undefined) {
          this.setState({
            fetchError: true
          });
        }
      });

    this.setState({
      pendingRequest: pendingRequest
    });
  }

  handleResponse = (apiResult) => {
    this.setState({
      fetchingMore: false,
      fetchingInitial: false,
      salaries: apiResult.collection,
      contentFetched: true,
      total: apiResult.meta.total,
      totalPages: Math.ceil(apiResult.meta.total / apiResult.meta.currentPage),
      meta: apiResult.meta
    });
  }

  handleSumResponse = (apiResult) => {
    this.setState({
      salarySums: apiResult
    });
  }

  handlePaginationClick = (data) => {
    this.setState({
      page: data.selected + 1,
      fetchingMore: true
    }, () => this.fetchSalaries(this.props.user.id, this.props.dateFilter));
  }

  renderLoader = () => {
    var tableContent, classes;

    tableContent = this.state.contentFetched ? this.renderTable() : false;
    classes = this.state.contentFetched ? 'loader-wrapper absolute' : 'loader-wrapper';

    return (
      <div className='table-loading'>
        <div className={classes}>
          <Spinner />
        </div>
        {tableContent}
        <div className='overlay'></div>
      </div>
    );
  }

  renderTable = () => {
    const canGenerateSalarySpecification = this.canGenerateSalarySpecification;
    const selectAllSalaries = this.selectAllSalaries;
    const toggleSalary = this.toggleSalary;
    const showSalarySpecification = this.showSalarySpecification;
    const showSalarySpecificationForSelected = this.showSalarySpecificationForSelected;

    return (
      <div>
        <div className='table-wrapper mobile-full-width-table'>
          <table className='standard-table'>
            <thead>
              <tr>
                <th className='col-gross-sum'><Translate content='GROSS_SUM' /></th>
                <th className='col-tax-sum'><Translate content='TAX_SUM' /></th>
                <th className='col-allowance-sum'><Translate content='ALLOWANCE_SUM' /></th>
                <th className='col-travel-sum'><Translate content='TRAVEL_SUM' /></th>
                <th className='col-net-sum'><Translate content='NET_SUM' /></th>
              </tr>
            </thead>
            <tbody>
              <SalarySums sums={this.state.salarySums} />
            </tbody>
          </table>
        </div>
        <div className='table-wrapper mobile-full-width-table'>
          <table className='standard-table'>
            <thead>
              <tr>
                <th className='col-check'>
                  <input id='check-all' type='checkbox' name='check-all'
                    checked={this.state.selectAllSalaries} onClick={selectAllSalaries} />
                  <label htmlFor='check-all'><span></span></label>
                </th>
                <th className='col-customer'><Translate content='CUSTOMER' /></th>
                <th className='col-ordernr'><Translate content='ORDER_NR' /></th>
                <th className='col-pay-id'><Translate content='PAY_ID' /></th>
                <th className='col-date'><Translate content='WORK_DATE' /></th>
                <th className='col-pay-sum'><Translate content='PAY_SALARY' /></th>
                <th className='col-pay-date'><Translate content='SALARY_PAYMENT' /></th>
                <th className='col-in-links'><Translate content='PRINT' /></th>
              </tr>
            </thead>
            <tbody>
              {this.state.salaries.map(function (salary, i) {
                return <SalaryRow
                  salary={salary}
                  toggleSalary={toggleSalary}
                  showSalarySpecification={showSalarySpecification}
                  canGenerateSalarySpecification={canGenerateSalarySpecification}
                  key={i}
                />;
              })}
            </tbody>
          </table>
        </div>
        <a className='btn submit-btn mb35' onClick={showSalarySpecificationForSelected}>
          <span><Translate content='GET_SALARY_SPECIFICATION' /></span>
        </a>
      </div>
    );
  }

  canGenerateSalarySpecification = (salary) => {
    return salary.selected &&
      salary.paymentStatus === paidPaymentStatus &&
      [
        paidByFileCategory,
        paidManuallyCategory,
        paidInCashCategory,
        creditCategory
      ].includes(salary.categoryId);
  }

  showSalarySpecificationForSelected = () => {
    const salaryIds = [];
    this.state.salaries.forEach(salary => {
      if (this.canGenerateSalarySpecification(salary)) {
        salaryIds.push(salary.id);
      }
    });

    if (salaryIds.length > 0) {
      this.showSalarySpecification(salaryIds);
    }
  }

  showSalarySpecification = (salaryIds) => {
    this.createSalarySpecification(salaryIds);

    let win = window.open('', '_blank');
    win.document.title = proxyCounterpart('LOADING');
    win.document.body.innerHTML = SpinnerPage;

    this.setState({
      salarySpecificationWindow: win
    });
  }

  renderFetchError = () => {
    return (<p className='error'><Translate content='GENERAL_ERROR' /></p>);
  }

  renderNoResult = () => {
    return (<p className='info'><Translate content='NO_SALARIES' /></p>);
  }

  renderPagination = () => {
    if (this.state.contentFetched && this.state.meta.totalPages > 1) {
      return (
        <ReactPaginate
          breakLabel={<a href=''>...</a>}
          pageNum={this.state.meta.totalPages}
          marginPagesDisplayed={3}
          pageRangeDisplayed={this.state.pageRange}
          clickCallback={this.handlePaginationClick}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
          previousLabel=''
          nextLabel=''
          containerClassName='pagination' />
      );
    }

    return false;
  }

  getContent = () => {
    if (this.state.fetchError) {
      return this.renderFetchError();
    }
    if (this.state.fetchingInitial) {
      return (<Spinner />);
    }
    if (this.state.fetchingMore) {
      return this.renderLoader();
    }
    if (this.state.salaries.length === 0 && this.state.contentFetched) {
      return this.renderNoResult();
    } else {
      return this.renderTable();
    }
  }

  render = () => {
    var content = this.getContent();

    return (
      <div className='pay-checks'>
        <h2><Translate content='YOUR_SALARIES' /></h2>
        <p><Translate content='YOUR_SALARIES_TEXT' /></p>
        <DatepickerRange />

        {content}
        {this.renderPagination()}
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {
    dateFilter: state.filters.dateFilter,
    user: state.user
  };
};

export default connect(
  mapStateToProps
)(Salaries);



/** WEBPACK FOOTER **
 ** ./src/views/economy-view/salaries/salaries.js
 **/